import { Flex, Loader, LoaderProps, MantineColor, MantineSize, Text } from '@mantine/core';
import { ReactNode } from 'react';

export type LoadingBoxProps = {
  color?: MantineColor;
  size?: MantineSize;
  variant?: LoaderProps['variant'];
  loaderProps?: LoaderProps;
  children: ReactNode;
};

const LoadingBox = (props: LoadingBoxProps) => {
  return (
    <Flex mih={50} gap="md" justify="center" align="center" direction="row" wrap="wrap">
      <Loader variant={props.variant ?? 'bars'} color={props.color} size={props.size} {...props.loaderProps} />
      <Text>{props.children ?? 'Đang tải...'}</Text>
    </Flex>
  );
};

export default LoadingBox;
